import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataLoadService } from 'src/app/shared/services/data-load.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { globalVariables } from 'src/app/core/constants/globalVariables';

@Component({
  selector: 'app-hr-line-list-two',
  templateUrl: './../../../templates/forms/modals/hr-line-list-two.component.html'
})
export class HrLineListTwoComponent implements OnInit {

  @Input()
  modalShow: boolean = true;

  @Input()
  optionalParam: any;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "HrLineListTwoId"

  lineList: any[] = [];

  constructor(private dataLoadService: DataLoadService,
    public langService: LangService,
    public gridService: GridService) {
      this.colObj = [
        { headerName: langService.langData.lineName, field: 'LINE_NAME', sortable: true, resizable: true, hide: false },
        { headerName: langService.langData.remarks, field: 'REMARKS', sortable: true, resizable: true, hide: false }
      ];
     }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId); 
  }

  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.dataLoadService.load('FG_HR_COMM_LINE_LIST', JSON.parse(JSON.stringify({ P_COMPANY_NO: globalVariables.userInfo.company_NO }))).subscribe(results=>{
      this.lineList = results.body;
    })
  }

  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next(_item);
  }

}
